<template>
  <div class="hotel-preview-gallery mb-6 md:mb-0">
    <b-skeleton-img />
    <div class="hotel-preview-gallery__thumbnails hidden md:grid">
      <b-skeleton-img />
      <b-skeleton-img />
      <b-skeleton-img />
      <b-skeleton-img />
    </div>
    <div class="hotel-preview-gallery__thumbnails grid md:hidden">
      <b-skeleton-img />
      <b-skeleton-img />
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'HotelPreviewGallerySkeleton',
})
</script>
